// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__26TdD","col":"styles_col__NRy5L"};